<div class="single-page-content">
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/toolbox-icon.svg" alt="">
    </div>
    Solicitudes modificación mantención
  </h1>

  <div class="transition-width pr-4">
    <app-table [columns]="tableColumns" [data]="flattenedData">
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <a [routerLink]="['/approval-notification', visation.id]" class="status-pill"  title="Ver detalle">
            {{ visation.action }}
          </a>          
        </div>
      </ng-template>
    </app-table>
  </div>
</div>
